import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const career: RouteObject[] = [
  {
    path: ROUTES.career.root,
    lazy: async () => {
      const { JobsPage } = await import('../../pages/career');

      return { Component: JobsPage };
    },
  },
  {
    path: ROUTES.career.new,
    lazy: async () => {
      const { JobsFormPage } = await import('../../pages/career');

      return { Component: JobsFormPage };
    },
  },
  {
    path: ROUTES.career.edit,
    lazy: async () => {
      const { JobsFormPage } = await import('../../pages/career');

      return { Component: JobsFormPage };
    },
  },
  {
    path: ROUTES.career.copy,
    lazy: async () => {
      const { JobsFormPage } = await import('../../pages/career');

      return { Component: JobsFormPage };
    },
  },
];
